import { useRef, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";

const AgentDropdown = ({ visible, data, onSelect, onClose, style, showCoordinator = false }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div
      ref={popupRef}
      className="w-[250px] bg-white border border-gray-300 rounded-md p-2 absolute z-10"
      style={style}
    >
      <div className="w-full max-h-[150px] overflow-y-auto">
        {showCoordinator && (
          <>
            <div
              onClick={() => onSelect({ coordinatorRole: true }, "Listing Coordinator")}
              className="py-2 cursor-pointer hover:bg-themeColor hover:text-white text-[#1E293B] font-semibold px-2 rounded-lg border-b border-gray-100 mb-1"
            >
              Listing Coordinator (auto)
            </div>
            <div
              onClick={() =>
                onSelect({ transactionCoordinatorRole: true }, "Transaction Coordinator")
              }
              className="py-2 cursor-pointer hover:bg-themeColor hover:text-white text-[#1E293B] font-semibold px-2 rounded-lg border-b border-gray-100 mb-1"
            >
              Transaction Coordinator (auto)
            </div>
          </>
        )}

        {/* All Agents Option */}
        <div
          onClick={() => onSelect(null, "Unassign")}
          className="py-2 cursor-pointer hover:bg-themeColor hover:text-white text-gray-700 px-2 rounded-lg"
        >
          Unassign
        </div>

        {data.map((item) => {
          const label = `${item.firstname} ${item.lastname}`;
          return (
            <div
              key={item.id}
              onClick={() => onSelect(item, label)}
              className="flex items-center gap-2 w-full py-2 cursor-pointer hover:bg-themeColor hover:text-white px-2 rounded-lg"
            >
              {item.profilepicture ? (
                <img
                  src={item.profilepicture}
                  alt=""
                  className="w-6 h-6 rounded-full"
                />
              ) : (
                <FaUserCircle className="w-6 h-6 text-gray-400" />
              )}
              <span className="text-sm font-medium">{label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgentDropdown;
